import React, { useEffect, useRef, useState } from 'react';
import { View, Dimensions, StyleSheet, Keyboard } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { showSheet } from 'src/actions/SheetActions';
import CustomBottomSheet from 'src/components/bottom-sheet';
import { windowHeight, isWeb } from '../../../../../constants';
import { selectrootsheettype } from '../../../../../selectors/SheetSelector';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import FieldHeader from '../../../../../components/fields/field-header/FieldHeader.component';
import { useTranslation } from 'react-i18next';
import ValidLabelField from '../../../../../components/fields/valid-label-field/ValidLabelField.component';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import { defaultTheme } from '../../../../../theme';
import { useProfileSheba, useSheba } from '../../../../../hooks/useValidations';
import { selecetusertype } from '../../../../../selectors/User';
import { getApp } from '../../../../../actions/app';
import { CustomText } from '../../../../../components';
let animationFrameId;

const ShabaSheet = () => {
    const dispatch = useDispatch();
    const bottomSheetRef = useRef(null);
    const { t } = useTranslation()
    const { sheetId } = useSelector(state =>
        selectrootsheettype(state),
    );
    const [validationEnabled, setValidationEnabled] = useState(false);
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const infoSheba = useSelector(state => state?.user?.info?.iban ?? '').replace('IR', '');
    const shebaState = useSelector(state => state?.app?.sheba ?? '').replace('IR', '');

    const {
        value: sheba,
        setValue: setSheba,
        result: shebaValidation,
        checkError: shebaCheckError,
    } = useProfileSheba(!validationEnabled);

    useEffect(() => {
        switch (sheetId) {
            case 'shaba':
                openHandler();
                break;
            default:
                closeHandler();
                break;
        }
    }, [sheetId]);

    function openHandler() {
        setIsBottomSheetVisible(true);
        if (isWeb) return;
        bottomSheetRef.current?.expand();
    }

    function onRequestClose() {
        dispatch(showSheet({ sheetId: '' }));
    }

    function closeHandler() {
        switch (isWeb) {
            case true:
                bottomSheetRef?.current?.snapTo(() => 0);
                break;
            case false:
                bottomSheetRef.current?.close();
                break;
            default:
                break;
        }
    }


    function onSubmit() {
        Keyboard.dismiss();
        if (shebaCheckError()) {
            setValidationEnabled(true);
        } else {
            dispatch(getApp({ sheba: sheba == '' ? ' ' : sheba }));
            closeHandler();
        }
    }


    useEffect(() => {
        if (shebaState) {
            setSheba(shebaState.replace(' ', ''))
        } else {
            setSheba(infoSheba.replace(' ', ''))
        }
    }, [])


    if (isBottomSheetVisible) {
        return (
            <CustomBottomSheet
                onClose={onRequestClose}
                ref={bottomSheetRef}
                isTransparent={false}
                enablePanDownToClose={isWeb ? undefined : false}
                expandOnContentDrag={isWeb ? false : undefined}
                snapPoints={
                    isWeb
                        ? ({ minHeight }) => [1, 320]
                        : [320]
                }
                onSpringStart={() => {
                    animationFrameId = requestAnimationFrame(() => {
                        if (bottomSheetRef && bottomSheetRef?.current) {
                            if (bottomSheetRef && bottomSheetRef?.current && bottomSheetRef?.current?.height == 1) {
                                setTimeout(() => {
                                    dispatch(showSheet({ sheetId: '' }));
                                    setIsBottomSheetVisible(false);
                                }, 200)
                            }
                        }

                    });
                }}

                onSpringEnd={
                    isWeb
                        ? () => {
                            cancelAnimationFrame(animationFrameId)
                            if (bottomSheetRef?.current?.height < 2) {
                                dispatch(showSheet({ sheetId: '' }));
                                setIsBottomSheetVisible(false);
                            }
                        }
                        : undefined
                }
                defaultSnap={isWeb ? 320 : undefined}
                open={isBottomSheetVisible}
                scrollViewStyle={isWeb ? undefined : styles.scroll}
                blocking={isWeb ? true : undefined}
                onDismiss={() => {
                    closeHandler()
                }}
                scrollLocking={isWeb ? false : undefined}>
                <View
                    style={[styles.content]}>
                    <View style={styles.indicator} />
                    <FabBackButton
                        container_style={styles.closeBtn}
                        onPress={closeHandler}
                        icon={'closeIcon'}
                    />
                    <FieldHeader text={t('enter_sheba_number')} containerStyle={styles.title} />

                    <View style={{ width: '100%' }}>
                        <CustomText size={19} font={'700'} style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            zIndex: 100,
                            top: 21,
                            left: 20,
                        }}>
                            {'IR'}
                        </CustomText>
                        <ValidLabelField
                            inputStyle={{
                                flex: undefined,
                            }}
                            labelText={t('shaba_number')}
                            returnKeyType="done"
                            keyboardType="number-pad"
                            onEndEditing={onSubmit}
                            maxLength={24}
                            value={sheba}
                            onChangeText={(value) => {
                                if (value !== 'I') {
                                    setSheba(value.replaceAll('IR', ''))
                                } else {
                                    setSheba('')
                                }
                            }}
                            isError={validationEnabled && shebaCheckError()}
                            errorText={shebaValidation.error}
                        />
                    </View>
                    <PrimaryButton
                        title={t('record')}
                        containerStyle={styles.button}
                        onPress={onSubmit}
                    />
                </View>
            </CustomBottomSheet>
        );
    } else {
        return null;
    }
}

export default ShabaSheet


const styles = StyleSheet.create({
    scroll: {
        flex: 1,
    },
    irTextt: {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 100,
        top: 21,
        left: 20,
    },
    title: { marginTop: 24, marginHorizontal: 0 },
    content: {
        backgroundColor: defaultTheme.colors.whiteGrey0,
        width: Dimensions.get('window').width,
        alignItems: 'flex-end',
        height: 320,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        paddingHorizontal: 16,
    },
    button: {
        marginTop: 40,
        marginBottom: 20,
    }
})